import ProjectMember from "@/entities/project-member";

export interface ProjectMemberCardProps {
  name: string;
  icon: string;
  belongsTo: string;
}

export function ProjectMemberCardDecorator(
  member: ProjectMember
): ProjectMemberCardProps {
  return {
    name: member.name,
    icon: member.icon,
    belongsTo: member.group.name
  };
}
